var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Action, Actions, Selector, State, Store } from '@ngxs/store';
import { HistoryToolService } from '../../../image-editor/history/history-tool.service';
import { CloseForePanel } from '../../../image-editor/state/editor-state-actions';
import { HistoryNames } from '../../../image-editor/history/history-names.enum';
import { BaseToolState } from '../base-tool.state';
import { DrawerName } from '../../toolbar-controls/drawers/drawer-name.enum';
import { MarkAsDirty, OpenFrameControls } from './frame.actions';
var FRAME_STATE_DEFAULTS = {
    dirty: false,
    controlsOpen: false
};
var FrameState = /** @class */ (function (_super) {
    __extends(FrameState, _super);
    function FrameState(store, history, actions$) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.history = history;
        _this.actions$ = actions$;
        _this.toolName = DrawerName.FRAME;
        return _this;
    }
    FrameState.dirty = function (state) {
        return state.dirty;
    };
    FrameState.controlsOpen = function (state) {
        return state.controlsOpen;
    };
    FrameState.prototype.markAsDirty = function (ctx) {
        ctx.patchState({ dirty: true });
    };
    FrameState.prototype.openFrameControls = function (ctx) {
        ctx.patchState({ controlsOpen: true });
    };
    FrameState.prototype.applyChanges = function (ctx) {
        this.store.dispatch(new CloseForePanel());
        if (ctx.getState().dirty) {
            this.history.add(HistoryNames.FRAME);
        }
        ctx.patchState(FRAME_STATE_DEFAULTS);
    };
    FrameState.prototype.cancelChanges = function (ctx) {
        if (ctx.getState().dirty) {
            this.history.reload();
        }
        if (ctx.getState().controlsOpen) {
            ctx.patchState({ controlsOpen: false });
        }
        else {
            this.store.dispatch(new CloseForePanel());
            ctx.patchState(FRAME_STATE_DEFAULTS);
        }
    };
    __decorate([
        Action(MarkAsDirty),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FrameState.prototype, "markAsDirty", null);
    __decorate([
        Action(OpenFrameControls),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FrameState.prototype, "openFrameControls", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FrameState, "dirty", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FrameState, "controlsOpen", null);
    FrameState = __decorate([
        State({
            name: 'frame',
            defaults: FRAME_STATE_DEFAULTS
        }),
        __metadata("design:paramtypes", [Store,
            HistoryToolService,
            Actions])
    ], FrameState);
    return FrameState;
}(BaseToolState));
export { FrameState };
